module.exports = __webpack_public_path__ + "img/brand1.c3395658.png";